import React from "react";
import theme from "theme";
import { Theme, Box, Section, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";

export default () => {
  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"404"} />
      <Components.CombinedHelmetNHeader />
      <Section
        padding="36px 0 60px 0"
        quarkly-title="HeroBlock"
        md-padding="16px 0 30px 0"
      >
        <Override
          slot="SectionContent"
          flex-direction="column"
          md-flex-wrap="wrap"
          flex-wrap="wrap"
        />
        <Box
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="60%"
          md-width="100%"
        >
          <Text
            font="--headline1"
            color="--light"
            margin="0px 0px 0px 0px"
            lg-font='normal 700 50px/1.2 "Quicksand", sans-serif'
            md-font='normal 700 40px/1.2 "Quicksand", sans-serif'
            md-margin="0px 0px 24px 0px"
          >
            Page not found, Error 404{"\n\n"}
          </Text>
        </Box>
        <Box
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="40%"
          md-width="100%"
          empty-min-width="64px"
        >
          <Text
            color="--light"
            font="--lead"
            text-align="justify"
            lg-font='normal 600 16px/1.5 "Varta", sans-serif'
            lg-margin="80px 0px 0px 0px"
            md-margin="0px 0px 0px 0px"
            margin="100px 0px 0px 0px"
          >
            The page is not valid, or this link is broken, or the page has been
            moved. Try hitting the back button or going to the homepage.
          </Text>
        </Box>
        {/* <Image
          object-fit="cover"
          object-position="0% 85%"
          lg-max-height="400px"
          sm-max-height="250px"
          margin="40px 0px 0px 0px"
          width="100%"
          src="https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80"
          max-height="600px"
          srcSet="https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80 500w,https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80 800w,https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1080&q=80 1080w,https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80 1600w,https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80 2000w,https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2600&q=80 2600w,https://images.unsplash.com/photo-1544453850-eaea85b2ae36?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3200&q=80 3200w"
          sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
        /> */}
      </Section>
      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
